import script from "./GenreSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenreSelection.vue?vue&type=script&setup=true&lang=ts"

import "./GenreSelection.vue?vue&type=style&index=0&id=482f52ff&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482f52ff"]])

export default __exports__